module.exports = __webpack_public_path__ + "resource/static/img/topbg@1.5x.f72827b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/topbg@1.5x.png
// module id = DjAM
// module chunks = 1